




























































































































































































































































































































































import {
  WorkflowConstraintActionEnum,
  WorkflowFormSectionFieldConstraint,
  IWorkflowFormSectionFieldData,
  IWorkflowFormSectionFieldConstraintData,
  IWorkflowFormSectionFieldConstraint,
  WorkflowConstraintConditionTypeEnum,
  WorkflowFormFieldConstraintComparisonOperators,
  IWorkflowFormFieldData
} from '@/models';
import { ErrorManager } from '@/models/error';
import { PropertyTabs } from '../WorkflowFormBuilderPropertiesDrawer.vue';

import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import WorkflowFormBuilderConstraintConditionsDrawer from '../WorkflowFormBuilderConstraintConditionsDrawer.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import { extractTextFromHtml } from '@/utils/helpers';

export interface WorkflowFormBuilderConstraintConditionsTabOptions
  extends InstanceType<typeof Vue> {
  isFormDisabled: boolean;
}

export default Vue.extend<WorkflowFormBuilderConstraintConditionsTabOptions>({
  functional: false
}).extend({
  name: 'FormBuilderConstraintsTab',

  components: {
    ErrorAlert,
    ConfirmationDialog,
    WorkflowFormBuilderConstraintConditionsDrawer
  },

  props: {
    sectionFields: Array as PropType<IWorkflowFormSectionFieldData[]>,
    selectedFieldIndex: Number,
    templateId: Number
  },

  inject: {
    isFormDisabled: {
      default: false
    }
  },

  data() {
    return {
      PropertyTabs,
      WorkflowConstraintActionEnum,
      WorkflowConstraintConditionTypeEnum,

      loading: false,
      errorMessage: '',
      detailErrorMessage: '',

      deleteDialog: false,
      selectedDeleteConstraintIndex: -1,

      drawer: false,

      constraintOptions: [
        { label: 'Required', value: WorkflowConstraintActionEnum.Required },
        { label: 'Optional', value: WorkflowConstraintActionEnum.Optional },
        { label: 'Disabled', value: WorkflowConstraintActionEnum.Disabled },
        { label: 'Hidden', value: WorkflowConstraintActionEnum.Hidden },
        { label: 'Visible', value: WorkflowConstraintActionEnum.Visible }
      ],
      selectedConstraint: {} as IWorkflowFormSectionFieldConstraintData,

      activePanel: 0
    };
  },

  computed: {
    ...mapGetters({
      getWorkflowFormFieldById: 'workflowFormTemplate/getWorkflowFormFieldById',
      getWorkflowFormFieldsOptionByTemplateIdAndOptionId:
        'workflowFormTemplate/getWorkflowFormFieldsOptionByTemplateIdAndOptionId',
      getWorkflowFormFields: 'workflowFormTemplate/getWorkflowFormFields'
    }),

    selectedField(): IWorkflowFormFieldData {
      return this.sectionFields[this.selectedFieldIndex]
        .field_template as IWorkflowFormFieldData;
    }
  },

  mounted() {
    this.loading = true;
    this.fetchWorkflowFormFields()
      .catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapActions({
      fetchWorkflowFormFields: 'workflowFormTemplate/fetchWorkflowFormFields'
    }),
    extractTextFromHtml,

    getWorkflowFormFieldConstraintComparisonTypeByType:
      WorkflowFormFieldConstraintComparisonOperators.getWorkflowFormFieldConstraintComparisonTypeByType,

    getWorkflowFormFieldIdBySectionFieldId(
      sectionFieldId: number
    ): number | undefined {
      const sectionField = this.sectionFields.find(
        field => field.id === sectionFieldId
      );

      return sectionField
        ? (sectionField.field_template as IWorkflowFormFieldData).id
        : undefined;
    },

    openDrawer(constraint: IWorkflowFormSectionFieldConstraintData) {
      this.selectedConstraint = constraint;
      this.drawer = true;
    },

    goToTabWindow(tab: PropertyTabs) {
      this.$emit('goToTabWindow', tab);
    },

    openDeleteDialog(index: number) {
      this.selectedDeleteConstraintIndex = index;
      this.deleteDialog = true;
    },

    closeDeleteDialog() {
      this.selectedDeleteConstraintIndex = -1;
      this.deleteDialog = false;
    },

    removeConstraint() {
      this.sectionFields[this.selectedFieldIndex].constraints.splice(
        this.selectedDeleteConstraintIndex,
        1
      );

      this.closeDeleteDialog();
    },

    async setSelectedConstraintOption(type: WorkflowConstraintActionEnum) {
      const instance = new WorkflowFormSectionFieldConstraint({
        action: type,
        conditions: []
      });

      this.sectionFields[this.selectedFieldIndex].constraints.push(instance);

      this.activePanel =
        this.sectionFields[this.selectedFieldIndex].constraints.length - 1;
    },

    clearAllErrors() {
      this.detailErrorMessage = '';
      this.errorMessage = '';
    }
  }
});
